import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage
          ? 'bg-white shadow-md py-3'
          : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/0c299f92b041db126467232eab95e64d/e9f4875b345447bd97ec5946624fd7c3.png"
              alt="Cosmetica Pro Shop Valencia"
              className={`transition-all duration-300 ${
                isScrolled ? 'h-14' : 'h-16'
              }`}
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
            >
              INICIO
            </Link>
            <Link
              to="/catalogo"
              className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
            >
              CATÁLOGO
            </Link>
            <a
              href="/#marcas"
              className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
            >
              MARCAS
            </a>
            <a
              href="/#tienda"
              className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
            >
              TIENDA
            </a>
            <a
              href="/#contacto"
              className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
            >
              CONTACTO
            </a>
          </div>

          {/* Icons */}
          <div className="flex items-center gap-4">
            <button className="w-9 h-9 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors cursor-pointer">
              <i className="ri-search-line text-xl"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors cursor-pointer">
              <i className="ri-user-line text-xl"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors cursor-pointer relative">
              <i className="ri-shopping-cart-line text-xl"></i>
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-stone-900 text-white text-xs rounded-full flex items-center justify-center">
                0
              </span>
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors cursor-pointer"
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-stone-200 pt-4">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
              >
                INICIO
              </Link>
              <Link
                to="/catalogo"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
              >
                CATÁLOGO
              </Link>
              <a
                href="/#marcas"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
              >
                MARCAS
              </a>
              <a
                href="/#tienda"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
              >
                TIENDA
              </a>
              <a
                href="/#contacto"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-stone-700 hover:text-stone-900 font-medium text-sm transition-colors cursor-pointer"
              >
                CONTACTO
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
